import React, { Component } from 'react';
import Card from '../../pages/components/Card';
import ReactTable from 'react-table';
import 'react-table/react-table.css';


export default class ManagementTable extends Component {
 render() {
   const { title, columns, data, renderToolbar, loading } = this.props;


   return (
     <Card
       title={title}
       showHeader={true}
       showExport={false}
       loading={loading}
       renderToolbar={renderToolbar ? renderToolbar() : null}
     >
       <div style={{ overflowX: 'auto' }}>
         <ReactTable
           data={data}
           columns={columns}
           defaultPageSize={10}
           className="-striped -highlight"
           noDataText="No records found"
           showPagination={true}
         />
       </div>
     </Card>
   );
 }
}
ManagementTable.defaultProps = {
 loading: false,
};

